'use strict';
import AbstractChart from './abstract-chart';

export default class ScoreGraph extends AbstractChart {
  constructor(targetElementId, seriesLabels = [], filters = [], type = 'anime') {
    super();
    this.isDarkMode = document.body.parentElement.classList.contains('dark-mode');
    this.isSp = document.body.classList.contains('sp');
    this.targetElementId = targetElementId;
    this.seriesLabels = seriesLabels;
    this.type = type;
    this.filterSubject.next(filters || [
      {
        key: 'statuses',
        value: 'completed',
        label: 'Completed',
        type: 'check',
        position: 'filter'
      }
    ]);
    this.subscribes = [];
  }

  renderGraph() {
    if (!document.getElementById(this.targetElementId)) {
      throw new DOMException(`Target Element Id (${this.targetElementId}) not found.`);
    }
    this.chart = am4core.create(`${this.targetElementId}`, am4charts.XYChart);
    this.endpoint = document.querySelector(`#${this.targetElementId}`).dataset.endpoint;
    this.chart.dataSource.url = this.endpoint;
    this.noDataIndicator.createNoDataIndicator(this.chart);
    // ここで入ってきたデータの処理を行う
    this.manipulateDataSource();
    // Tooltip拡張。XYCursor
    this.createXYCursor();
    // グローバル設定はここ
    this.settingChart();
  }

  renderScoreGraph() {
    const $filter_block = $(document.querySelector(`#${this.targetElementId}-filters`));
    const $button_tmpl = $.templates('#statistics-filter-button');
    this.renderGraph();
    this.renderFilterButtons($filter_block, $button_tmpl, ([prev, filters]) => {
      if (prev) { // 初回のみnullが来るのでロードしない
        this.chart.dataSource.load();
      }
    });
    // Score
    this.createScoreLabelAxis();
    this.createScoreRatioAxis();
    // データ軸
    this.createValueAxis();
    this.settingSeries().then(s => this.series = s);
  }

  renderOverviewGraph() {
    this.renderGraph();
    // Score
    this.createScoreLabelAxis();
    // データ軸
    this.createValueAxis();
    this.getCustomColors().then((customColors) => {
      this.series = {};
      this.seriesLabels.map(e => { // カスタムカラー設定がある場合は、ここで上書きしてseriesを作る
        if (customColors[e.value]) {
          e.color = customColors[e.value + (this.isDarkMode ? '.dark' : '')];
        }
        return e;
      }).forEach(e => this.series[e.value] = this.createSeries(e.label, e.value, e.color, (dataItem, item) => {
        return `Days spent: ${dataItem['item_days_spent']}<br>${this.type.charAt(0).toUpperCase() + this.type.slice(1)} count: {${item.dataFields.valueX}}`;
      }));
    });
  }

  async getCustomColors() {
    const customEndpoint = document.querySelector(`#${this.targetElementId}`).dataset.colorEndpoint;
    if (customEndpoint) {
      const customColors = await (await fetch(customEndpoint)).json();
      if (customColors.list_status_colors && customColors.list_status_colors[this.type]) {
        return customColors.list_status_colors[this.type];
      }
    }
    return {};
  }

  async settingSeries() {
    const customColors = await this.getCustomColors();
    const series = {};
    this.seriesLabels.map(e => { // カスタムカラー設定がある場合は、ここで上書きしてseriesを作る
      if (customColors[e.value]) {
        e.color = customColors[e.value + (this.isDarkMode ? '.dark' : '')];
      }
      return e;
    }).forEach(e => series[e.value] = this.createSeries(e.label, e.value, e.color, (dataItem, item) => {
      const format = (str) => typeof str === 'string'
        ? str.split('_').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ') : str; // 最初だけ大文字にする
      return `<span style="color: ${item.columns.template.stroke};">&#x2B24;</span> ` + `${format(item.dataFields.valueX)} : {${item.dataFields.valueX}}\n`;
    }));
    return series;
  }

  finishLoading() {
    const loading = $(`#${this.targetElementId}-loading`);
    if (!loading.hasClass('hidden')) {
      loading.addClass('hidden');
      document.dispatchEvent(new Event('statistics_loaded'));
    }
  }

  manipulateDataSource() {
    this.chart.dataSource.adapter.add('parsedData', (data) => {
      // もしデータ量が足りてなかった場合は、足りないアラートを出す
      if (data.is_lt_10_title || data.is_complete_title_lt_5 || !data.result) {
        $(`#${this.targetElementId}-nodata`).removeClass('hidden');
        $(`#${this.targetElementId}`).closest('.chart-root').addClass('nodata');
        $(`#${this.targetElementId}`).closest('.chart-root').find('.sp-toggle-filter-btn').prop('disabled', true);
        $(`#${this.targetElementId}-info`)
          .html($.templates(!data.result || data.is_lt_10_title ? '#statistics-info-list-le10-tmpl' : '#statistics-info-complete-le5-tmpl').render({
            ...data,
            type: this.type
          }));
      }
      this.mappingFooter(data.result ? data : null);
      $(`#${this.targetElementId}-info-score`).html($.templates('#statistics-info-score-tmpl').render({
        ...data,
        type: this.type
      }));
      this.finishLoading();
      if ((data['items'] || []).length === 0) {
        this.noDataIndicator.showNoDataIndicator();
      } else {
        this.noDataIndicator.hideNoDataIndicator();
      }
      return (data.result ? data['items'] : []);
    });
    this.chart.dataSource.adapter.add('url', (url) => {
      const query = new URLSearchParams();
      this.filterSubject.value.filter(r => r.active).forEach(r => {
        if (r.key === 'dated_at' && r.value.startsWith('custom')) {
          r.value.split('&').forEach(function(queryStr, index) {
            if (index === 0) {
              // dated_at=custom
              query.append(r.key, queryStr);
              return;
            }
            const queryArr = queryStr.split('=');
            query.append(queryArr[0], queryArr[1]);
          });
        } else {
          query.append(r.key, r.value);
        }
      });
      return `${url}&${query}`;
    });
    this.chart.events.on('datavalidated', (ev) => {
      if (ev.target.data.length > 0) {
        this.chart.appear();
        this.chart.series.each((series) => {
          series.appear();
        });
      }
    });
  }

  mappingFooter(data) {
    const footer = document.querySelector(`#${this.targetElementId}-footer`);
    if (footer && data) {
      Array.from(footer.querySelectorAll('[data-chart-footer-text-key]')).forEach(elm => {
        const key = elm.dataset.chartFooterTextKey;
        elm.querySelector('.value').innerText = data[key] || 0;
      });
      footer.style.display = '';
    }
  }

  settingChart() {
    // zoom outボタン消す。show/hideした時に出てくるから
    this.chart.zoomOutButton.disabled = true;
    this.chart.preloader.disabled = true;
    this.chart.paddingLeft = 0;
    this.chart.paddingRight = 0;
  }

  createXYCursor() {
    this.chart.cursor = new am4charts.XYCursor();
    this.chart.cursor.maxTooltipDistance = -1; // どれぐらいの距離、カーソルと離れていたらtooltipを出すか。-1なら絶対１つだけ。
    this.chart.cursor.lineY.disabled = true;
    this.chart.cursor.lineX.disabled = true;
    this.chart.cursor.behavior = 'none'; // zoom in/outなどの動きを無効化
  }

  createValueAxis() {
    const valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.disabled = true; // 軸の非表示化
    valueAxis.renderer.labels.template.disabled = true; // 値軸のラベルを非表示
    valueAxis.renderer.baseGrid.disabled = true; // 0の位置の罫線を非表示
    valueAxis.cursorTooltipEnabled = false;
    valueAxis.rangeChangeDuration = 0;
    return valueAxis;
  }

  createScoreLabelAxis() {
    const axis = this.createBaseCategoryAxis(this.chart);
    axis.renderer.labels.template.paddingLeft = 0;
    return axis;
  }

  createScoreRatioAxis() {
    const chart = this.chart;
    const createAxis = () => {
      const category = this.createBaseCategoryAxis(this.chart);
      category.renderer.opposite = true;
      category.renderer.labels.template.align = 'right';
      category.renderer.labels.template.fill = am4core.color('#787878');
      category.renderer.labels.template.paddingLeft = 10;
      category.renderer.labels.template.paddingRight = 0;
      return category;
    };
    const [ratioAxis, scoreAxis] = [createAxis(), createAxis()];

    scoreAxis.renderer.labels.template.adapter.add('text', (text, target) => {
      const sum = (...values) => values.reduce((a, b) => a + b, 0);
      const calcDataRow = (row) => !!row ? sum.apply(null, this.seriesLabels.map(s => row.hasOwnProperty(s.value) ? row[s.value] || 0 : 0)) : 0;
      const rowTotal = calcDataRow(target.dataItem.dataContext);
      return `${rowTotal}`;
    });
    ratioAxis.renderer.labels.template.adapter.add('text', (text, target) => {
      const sum = (...values) => values.reduce((a, b) => a + b, 0);
      const calcDataRow = (row) => !!row ? sum.apply(null, this.seriesLabels.map(s => row.hasOwnProperty(s.value) ? row[s.value] || 0 : 0)) : 0;
      const total = sum.apply(null, chart.data.map((d) => calcDataRow(d)));
      const rowTotal = calcDataRow(target.dataItem.dataContext);
      const calcPercent = (a, b) => {
        const p = a / b;
        return (!isFinite(p) || isNaN(p)) ? 0 : Math.floor(p * 100);
      };
      let rowPercent = calcPercent(rowTotal, total).toString();
      return `(${rowPercent}%)`;
    });
    return [scoreAxis, ratioAxis];
  }

  createBaseCategoryAxis() {
    const category = this.chart.yAxes.push(new am4charts.CategoryAxis());
    category.dataFields.category = 'item';
    category.renderer.grid.template.disabled = true; // 軸の非表示化
    category.min = 1;
    category.max = 10;
    category.renderer.minGridDistance = 1; // ラベルの分割単位
    category.renderer.grid.template.location = 0;
    category.renderer.labels.template.fontSize = 12;
    category.renderer.cellStartLocation = 0.1;
    category.renderer.cellEndLocation = 0.9;
    category.cursorTooltipEnabled = false;
    return category;
  }

  createSeries(cat_label, cat_val, cat_color, tooltipTextFunc) {
    const chart = this.chart;
    const series = this.chart.series.push(new am4charts.ColumnSeries());
    const cornerRadius = (radius, item) => {
      const dataItem = item.dataItem;
      // Find the last series in this stack
      const lastSeries = chart.series.values.filter(s => dataItem.dataContext[s.dataFields.valueX] && !s.isHidden && !s.isHiding).pop();
      // If current series is the one, use rounded corner
      return dataItem.component === lastSeries ? 3 : radius;
    };

    series.stacked = true;
    series.dataFields.valueX = cat_val;
    series.dataFields.categoryY = 'item';
    series.name = cat_label;
    series.columns.template.fill = am4core.color(cat_color);
    series.columns.template.stroke = am4core.color(cat_color);
    series.columns.template.strokeWidth = 0;
    series.columns.template.tooltipX = am4core.percent(100);
    series.columns.template.column.adapter.add('cornerRadiusBottomRight', cornerRadius);
    series.columns.template.column.adapter.add('cornerRadiusTopRight', cornerRadius);
    series.tooltip.getFillFromObject = false;
    series.tooltip.background.fill = am4core.color('#333333');
    series.tooltip.label.fill = am4core.color('#FFF');
    series.tooltip.background.strokeWidth = 0;
    series.tooltip.label.fontSize = 11;
    series.tooltip.pointerOrientation = 'left';
    series.animationDuration = 300;
    series.showOnInit = false;
    // Score: 4 - Bad
    // ○ Completed: 7
    if (this.isSp) {
      series.tooltip.disabled = true;
    }
    series.tooltipHTML = '<p>Score: {categoryY} - </p>';
    if (tooltipTextFunc) {
      series.adapter.add('tooltipHTML', function(_text, target) {
        // 対象のデータアイテムを取得
        const dataItem = target.tooltipDataItem.dataContext || {};
        const lastKey = ['completed', 'watching', 'reading', 'on_hold', 'dropped'].filter(key => dataItem[key] > 0).pop();
        if (cat_val !== lastKey) {
          return '';
        }
        // データアイテムのscoreを取得
        let text = `<p>Score: {categoryY} - ${dataItem.item_label || ''}<br>`;
        chart.series.each(function(item, index) {
          if (dataItem[item.dataFields.valueX] > 0) {
            text += tooltipTextFunc(dataItem, item) + '<br>';
          }
        });
        return text + '</p>';
      });
    }
    return series;
  }
}
